<p>dialog-checks works!</p>
